import React from 'react';
import styled, { css } from 'styled-components';

import { Moon } from '@lt/components/icons-react/userflow';
import { pluralizeNights } from '../../../../../../../../utils';
import { CalendarProps } from '../../types';
import { getRangeNightsString } from '../../utils';

type Props = Pick<CalendarProps, 'endShift' | 'startShift' | 'isMobile'> & {
  startDate: Date;
  endDate: Date;
};

export const NightsInfo = ({ startDate, startShift, endDate, endShift, isMobile }: Props) => {
  const { maxNights, minNights } = getRangeNightsString({
    startDate,
    endDate,
    startShift,
    endShift,
  });
  return (
    <NightsBlock $isMobile={isMobile}>
      <span>
        {minNights && `${minNights}...`}
        {maxNights}
        <MoonIcon />
      </span>
      <span>{pluralizeNights(maxNights)}</span>
    </NightsBlock>
  );
};

const NightsBlock = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  font-size: 14px;
  line-height: 16px;
  color: #919499;
  margin: 8px 0 0 0;

  & * + * {
    margin-left: 4px;
  }

  ${({ $isMobile }) =>
    $isMobile &&
    css`
      margin: 0 0 8px 0;
    `};
`;

const MoonIcon = styled(Moon)`
  width: 12px;
  transform: translate(0px, 1px);

  path {
    fill: #919499;
  }
`;
